import store from './redux/store';
import { receiveUsers } from './redux/entities/users/usersActions';
import { receiveWaiverWorkItemResolutions } from './redux/entities/waivers/workItems/waiverWorkItemResolutionsActions';
import { receiveBrandingImage } from './redux/entities/brandingImage/brandingImageActions';
import setupInterceptors from './lib/axiosInterceptor';
import { DecoratedUser, User } from './types/user';
import { Resolution } from './types/waiverWorkItem';

interface ReactAgentSpaProps {
  user: DecoratedUser;
  users?: any;
  development?: any;
  aav1Host?: any;
  resolutions?: any;
  locals?: {
    preloadData?: {
      brandingImageUrl?: string;
    };
  };
}

const ReactAgentSpa = (props: ReactAgentSpaProps) => {
  const {
    user,
    users,
    development,
    aav1Host,
    resolutions,
    locals
  } = props;
  setupInterceptors(store);
  const dispatch = store.dispatch;
  const setSession = (value: any) => dispatch({ type: 'setConfig', response: value });
  const setUsers = (users: User[]) => dispatch(receiveUsers(users));
  const setWaiverWorkItemResolutions = (resolutions: Resolution[]) => dispatch(receiveWaiverWorkItemResolutions(resolutions));
  const setTravelerBrandingImageUrl = (imageUrl: string) => dispatch(receiveBrandingImage(imageUrl));

  setSession({ session: user, aav1Host, development });
  setUsers(users);
  setWaiverWorkItemResolutions(resolutions);

  if (locals?.preloadData?.brandingImageUrl) {
    setTravelerBrandingImageUrl(locals.preloadData.brandingImageUrl);
  }
}

export default ReactAgentSpa;